import { render } from "./SidebarItem.vue?vue&type=template&id=8a07b36a"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"

import "./SidebarItem.vue?vue&type=style&index=0&id=8a07b36a&lang=css"

import exportComponent from "C:\\Users\\david\\Documents\\Dada\\Omnichannel-Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__